"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var DraggableColumnModel = /** @class */ (function () {
    function DraggableColumnModel(meta) {
        this.cellCount = 3;
        this.disabled = false;
        this.checkedInLayout = false;
        this.metaFieldId = meta.getMetaFieldId();
        this.systemName = meta.getMetaFieldId().getSystemName();
        this.displayNameMsgId = meta.getDisplayNameMsgId();
        this.type = meta.getType();
        this.isMultiline = meta.getIsMultiline();
        this.compoundCategorySystemName = meta.getCompoundCategorySystemName();
        this.maxLength = meta.getMaxLength();
        this.fieldPrefix = meta.getFieldPrefix();
        this.id = this.uniqueId();
        if (meta.getDisplayNameMultilingual()) {
            this.fieldMultilingualDisplayName = this.multiLingualToJson(meta.getDisplayNameMultilingual());
        }
    }
    DraggableColumnModel.prototype.uniqueId = function () {
        return 'xxxxxxxx'.replace(/[xy]/g, function (c) {
            // tslint:disable:no-bitwise
            var r = (Math.random() * 16) | 0, // NOSONAR
            // tslint:disable-next-line:no-bitwise
            v = c === 'x' ? r : (r & 0x3) | 0x8;
            return v.toString(16);
            // tslint:enable:no-bitwise
        });
    };
    DraggableColumnModel.prototype.multiLingualToJson = function (multiString) {
        var obj = {};
        multiString
            .toMap()
            .forEach(function (value, key) { return (obj[key] = value); });
        return obj;
    };
    return DraggableColumnModel;
}());
exports.DraggableColumnModel = DraggableColumnModel;
//# sourceMappingURL=draggable-column.model.js.map